import React from 'react'
import FontFile from '../shared/font-file'


const Word = (props) => { 
  return <FontFile 
            font={'sans-serif'} 
            topOffset='0.2em'
            multiplier={1}
            {...props}
            borderColor={props.backCol} 
          />
}

export default Word